module.exports = __webpack_public_path__ + "static/media/climbing_view_tiny.e8f9acf4.webp";